import { MedicalInformationType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

export const findFirstAvailableMedicalInformationType = (
   availableMedicalInformationTypes: MedicalInformationType[] | undefined
): MedicalInformationType | null =>
   availableMedicalInformationTypes?.length === 1 ? availableMedicalInformationTypes[0] : null;
